module.exports = __webpack_public_path__ + "img/icon-mp4.a205bf15.svg";